import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // Added useLocation
import { all_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Button } from "antd";


const Header = () => {
  // const { keycloak } = useKeycloak();
  const routes = all_routes;
  const location = useLocation(); // Added useLocation hook
  // const userRoles = keycloak.tokenParsed?.realm_access?.roles || [];
  const isAdmin = false;
  const isAdminOrHomePage = location.pathname === routes.admin || location.pathname === routes.home;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
  };

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('menu-opened');
    } else {
      document.body.classList.remove('menu-opened');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('menu-opened');
    };
  }, [isMobileMenuOpen]);

  type MenuItem = {
    tittle: string;
    showAsTab: boolean;
    separateRoute: boolean;
    routes: string;
    hasSubRoute: boolean;
    showSubRoute: boolean;
    menu?: any[];
  };

  const header = [
    {
      tittle: "Acasă",
      showAsTab: false,
      separateRoute: true,
      routes: "/home",
      hasSubRoute: false,
      showSubRoute: false,
    },
    !isAdmin && {
      tittle: "Showroom",
      showAsTab: false,
      separateRoute: true,
      routes: "/listing-grid",
      hasSubRoute: false,
      showSubRoute: false,
    },
    !isAdmin && {
      tittle: "Vreau masina pe comanda",
      showAsTab: false,
      separateRoute: true,
      routes: routes.carRequest,
      hasSubRoute: false,
      showSubRoute: false,
    },
    !isAdmin && {
      tittle: "Despre noi",
      showAsTab: false,
      separateRoute: true,
      routes: routes.aboutus,
      hasSubRoute: false,
      showSubRoute: false,
    }
  ].filter((item): item is MenuItem => Boolean(item));


  return (
    <>
      {/* Mobile Menu Backdrop */}
      {isMobileMenuOpen && (
        <div
          className="sidebar-overlay"
          style={{ display: 'block' }}
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <header className="header header-modern">
        <div className="container-fluid">
          <nav className="navbar navbar-expand-lg header-nav">
            <div className="navbar-header">
              <Link id="mobile_btn" to="#" onClick={toggleMobileMenu}>
                <span className="bar-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </Link>
              <Link to={routes.home} className="navbar-brand logo logo-modern">
                <div className="d-flex align-items-center">
                  <ImageWithBasePath
                    src="assets/img/logo.png"
                    className="img-fluid"
                    style={{ maxHeight: '45px', width: 'auto' }}
                    alt="Logo"
                  />
                  <div className="ms-3 brand-text-modern">
                    <span className="brand-name">AD SHOWROOM</span>
                    <span className="brand-tagline">Premium Auto</span>
                  </div>
                </div>
              </Link>
              <Link to={routes.home} className="navbar-brand logo-small logo-modern">
                <div className="d-flex align-items-center justify-content-center">
                  <ImageWithBasePath
                    src="assets/img/logo.png"
                    className="img-fluid"
                    style={{ maxHeight: '35px', width: 'auto' }}
                    alt="Logo"
                  />
                  <span className="ms-2 fw-bold" style={{ fontSize: '1rem', color: '#FFC107' }}>AD</span>
                </div>
              </Link>
            </div>
            <div className={`main-menu-wrapper ${isMobileMenuOpen ? 'slide-nav' : ''}`}>
              <div className="menu-header">
                <Link to={routes.home} className="menu-logo">
                  <ImageWithBasePath
                    src="assets/img/logo.png"
                    className="img-fluid"
                    alt="Logo"
                  />
                </Link>
                <Link id="menu_close" className="menu-close" to="#" onClick={closeMobileMenu}>
                  <i className="fas fa-times" />
                </Link>
              </div>
              {!isAdmin || isAdminOrHomePage ? (
                <ul className="main-nav main-nav-modern">
                  {header.map((mainMenus, mainIndex) => (
                    <React.Fragment key={mainIndex}>
                      {mainMenus.separateRoute ? (
                        <li className={location.pathname === mainMenus.routes ? 'active' : ''}>
                          <Link to={mainMenus.routes} onClick={() => setIsMobileMenuOpen(false)}>{mainMenus.tittle}</Link>
                        </li>
                      ) : (
                        <li className="has-submenu">
                          <Link to="#">
                            {mainMenus.tittle}{" "}
                            <i className="fas fa-chevron-down"></i>
                          </Link>
                          <ul
                            className={`submenu ${
                              mainMenus.showAsTab ? "d-block" : ""
                            }`}
                          >
                            {mainMenus.menu?.map((menu, menuIndex) => (
                              <li
                                key={menuIndex}
                                className={menu.hasSubRoute ? "has-submenu" : ""}
                              >
                                {menu.hasSubRoute ? (
                                  <React.Fragment>
                                    <a href="#">
                                      {menu.menuValue}{" "}
                                    </a>
                                    <ul
                                      className={`submenu ${
                                        menu.showSubRoute ? "d-block" : ""
                                      }`}
                                    >
                                      {menu.subMenus?.map(
                                        (subMenu: any, subMenuIndex: number) => (
                                          <li key={subMenuIndex}>
                                            <Link to={subMenu.routes}>
                                              {subMenu.menuValue}
                                            </Link>
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </React.Fragment>
                                ) : (
                                  <Link to={menu.routes}>{menu.menuValue}</Link>
                                )}
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              ) : null}
            </div>
            <ul className="nav header-navbar-rht header-cta-modern">
              <li className="nav-item">
                <a href="tel:+40774555555" className="btn-header-call">
                  <i className="feather-phone-call" />
                  <span>+40 774 555 555</span>
                </a>
              </li>
              <li className="nav-item">
                <Link to={routes.listinggrid} className="btn-header-primary">
                  <i className="feather-grid" />
                  <span>Vezi Stocul</span>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
